import { updateField } from 'vuex-map-fields'

// const SET_USER = (state, payload) => {
//   state.user = payload
// }

export default {
  updateField
}
